import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/aboutUs.css';

const AboutUsComponent = ({ variant = 'default' }) => {
  if (variant === 'compact') {
    return (
      <section className="section bg-white about-section about-compact">
        <div className="section-inner">
          <h2 className="section-title">About All Seasons</h2>
          <div className="about-wrapper">
            <div className="about-image">
              <img src="/images/team/treeWorkMen.JPG" alt="All Seasons team at work" />
              <div className="about-badge">35+ Years of Excellence</div>
            </div>
            <div className="about-content">
              <p>
                For more than three decades, All Seasons has cared for the landscapes of the Wood River Valley with integrity, craftsmanship, and an enduring commitment to quality. What began as a small local team built its reputation through word of mouth and a simple promise — to show up, follow through, and deliver work that lasts.
              </p>
              <p>
                Our people are the heart of who we are. Many of our team members have been with us for decades, bringing consistency, expertise, and pride to every property we care for. That dedication has built a culture of trust and reliability that continues to define All Seasons — providing the Valley with all services, all seasons.
              </p>
              <Link to="/TeamPage#about-us" className="compact-cta">
                MORE ABOUT US →
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Default version - text-focused, no image to keep section length manageable
  return (
    <section id="about-us" className="section bg-white about-section about-default">
      <div className="section-inner">
        <div className="about-default-header">
          <h2 className="section-title">About All Seasons</h2>
          <div className="about-badge-standalone">35+ Years of Excellence</div>
        </div>
        <div className="about-default-content">
          <p>
            Established more than three decades ago, All Seasons set out to provide reliable, year-round care for the landscapes of the Wood River Valley. What began as a small operation grew through word of mouth and a reputation for following through. Families and businesses came to know us not only for what we build and maintain, but also for the people behind the work.
          </p>
          <p>
            At All Seasons, our people are who we are. Many of our team members have been with us for 15 to 20 years exemplifying the loyalty, expertise, and pride that shapes our work. That dedication has created a culture of trust, both within our crews and the clients we serve.
          </p>
          <p>
            We continuously maintain our reputation through values of integrity and craftsmanship with an enduring commitment to quality. Today our construction and maintenance team brings local expertise to every property. From distinctive residential landscaping and large commercial developments to emergency snow management and maintenance; we handle it all.
          </p>
          <p>
            As our capabilities continue to grow, our roots remain the same with a focus on our people, our craftmanship and our trust. Providing the Wood River Valley with an all-in-one quality landscaper committed to reliability and excellence, season after season.
          </p>
          <p className="about-tagline">
            <strong>All Services. All Seasons. All Over the Wood River Valley.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsComponent;
